import React from 'react';
import { ItemModifiers } from '../../common/OrderPanel/Accordion';
import { filterItemModifier } from '../../dashboard/actions/cartActions.js';
import { FormattedMessage } from 'react-intl';
import defaultMsg from '../../../translations/lang/en-US.json';

class Modifier extends React.Component {
	render() {
		let modifiers = filterItemModifier({
			i: this.props.item.forced,
			r: {},
		}).r;
		if (!modifiers || Object.keys(modifiers).length < 1) {
			return (
				<div className="dim-text">
					<FormattedMessage
						id="noModifiers"
						defaultMessage={defaultMsg.noModifiers}
					/>
				</div>
			);
		}
		return <ItemModifiers cookedItems={modifiers} />;
	}
}

export default Modifier;



// WEBPACK FOOTER //
// ./src/views/inventory/components/Modifier.jsx